import { t } from 'i18next'
import { Close } from '@mui/icons-material'
import { Box, Drawer, IconButton, Typography } from '@mui/material'

import useDrawer from '@/hooks/ui/use-drawer.hook'
import useSnackbar from '@/hooks/ui/use-snackbar.hook'
import { DrawersEnum } from '@/enums'

import SnackbarWrapper from '@/views/components/snackbar/snackbar.component'
import { ContributionsBetDetailsReport } from '../drawer'

export const UiFeedbackContributionsComponent = () => {
  const { snackbar, closeHandler } = useSnackbar({})

  const { drawer, handleToggleDrawer } = useDrawer()

  const handleCloseDrawer = () => {
    handleToggleDrawer({ open: false, object: undefined })
  }

  return (
    <>
      <SnackbarWrapper
        message={snackbar.message}
        open={snackbar.open}
        handleClose={closeHandler}
        variant={snackbar.variant}
        automaticClose
      />
      <Drawer
        anchor="right"
        open={
          drawer.open &&
          drawer.id === DrawersEnum.DRAWER_CONTRIBUTIONS_BET_DETAILS
        }
        onClose={handleCloseDrawer}
      >
        <Box width="100vw" maxWidth={1000} p={4} overflow="auto">
          <Box display="flex" justifyContent="space-between">
            <Typography variant="h6">{t('transaction.betDetails')}</Typography>
            <IconButton aria-label="close" onClick={handleCloseDrawer}>
              <Close />
            </IconButton>
          </Box>
          <ContributionsBetDetailsReport id={drawer.object?.id} />
        </Box>
      </Drawer>
    </>
  )
}
